/**
 * Cookie Consent Constants
 * Defines constants and enums for cookie consent management
 */

/**
 * Cookie consent methods
 */
export const CONSENT_METHOD = {
  BANNER: 'banner',
  SETTINGS: 'settings',
  IMPLICIT: 'implicit',
};

/**
 * Cookie categories
 */
export const COOKIE_CATEGORY = {
  STRICTLY_NECESSARY: 'strictlyNecessary',
  FUNCTIONAL: 'functional',
  ANALYTICS: 'analytics',
  MARKETING: 'marketing',
};

/**
 * Platform types
 */
export const CONSENT_PLATFORM = {
  PARTNER: 'partner',
  PROFILE: 'profile',
};

/**
 * Current cookie policy version
 * Update this when the cookie policy is updated
 */
export const CURRENT_POLICY_VERSION = '1.0';

/**
 * Cookie consent expiry duration in months
 * GDPR recommendation: 13 months
 */
export const CONSENT_EXPIRY_MONTHS = 13;
